/* istanbul ignore file */

export function pluralize(
  value: string,
  amount: number,
  locale: string
): string | undefined {
  const pluralRule = new Intl.PluralRules(locale).select(amount);

  return `${value}.${pluralRule}`;
}
